import { loggedInUserHasPermission, loggedInUserHasRoleWithPermission } from '../lib'

export const hasViewInstallationPermission = () => loggedInUserHasPermission('VIEW_INSTALLATION_ASSORTMENT')
export const hasWriteInstallationPermission = () => loggedInUserHasPermission('WRITE_INSTALLATION_ASSORTMENT')
export const hasWriteCommonAssortmentPermission = () => loggedInUserHasPermission('WRITE_COMMON_ASSORTMENT')
export const hasViewAssortmentPermission = () => loggedInUserHasPermission('VIEW_ASSORTMENT_MANAGEMENT')

export const hasRestoreOverridesPermission = () =>
  loggedInUserHasRoleWithPermission('DatabaseManager', 'WRITE_INSTALLATION_ASSORTMENT')
